import React from 'react';
import { Card, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import EditableSectionDevelopment from "./EditableSectionDevelopment";

const { Title, Text } = Typography;

const DifferentiationCard = ({
    differentiationBrief,
    isEditMode,
    editingState,
    adaptedKeys,
    handleEdit,
    handleContentChange,
    handleSave,
    handleCancel,
    handleClearField
}) => {
    return (
        <div id="lesson-differentiation">
            <Title level={2}>Differentiation Overview</Title>
            <Card size="small" icon={<TeamOutlined />}>
                <EditableSectionDevelopment
                    contentKey="differentiationBrief"
                    editContent={editingState.key === 'differentiationBrief' ? editingState.content : differentiationBrief}
                    isEditing={editingState.key === 'differentiationBrief'}
                    isAdapted={adaptedKeys.has('differentiationBrief')}
                    onEdit={isEditMode ? handleEdit : undefined}
                    onChange={isEditMode ? handleContentChange : undefined}
                    onSave={isEditMode ? handleSave : undefined}
                    onCancel={isEditMode ? handleCancel : undefined}
                    onDelete={isEditMode ? () => handleClearField('differentiationBrief', 'Differentiation Overview') : undefined}
                    deleteTooltip="Clear overview"
                >
                    <Text>{differentiationBrief || <Text type="secondary" italic>Not specified</Text>}</Text>
                </EditableSectionDevelopment>
            </Card>
        </div>
    );
};

export default DifferentiationCard;
